import { default as Spinner } from "../svgSpinner";

// Re-exporting to fix annoying case sensitive type-ahead import issues in vscode.
export default Spinner;
